<template>
</template>


<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'News',
  components: {
  },
  setup() {
    return {
      
    }
  },
  methods: {
  }
});
</script>

